
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as project_45stategvVFtUXX0Lf8N7mTSxtiDncS9DsgOVLhkym0T6Mra6cMeta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/modules/project-analysis/runtime/pages/project-state.vue?macro=true";
import { default as indexjPEy6CQOiNh1rNT9pfifvZsdJSLNlrgYKYEgtHdsn70Meta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/index.vue?macro=true";
import { default as loginFc55R6x1suliyj2smacEE_t3PloOSaTKxMWatG1BHoMMeta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/login.vue?macro=true";
import { default as logoutgXQGpQCZQ7YlEuJoHuP5jnWB6sl68iYhX0rB9Ze6RYkMeta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/logout.vue?macro=true";
import { default as _91_46_46_46url_93aUAWQ3siV731zx1RHekBzO8wj3NrnbmGgm9Q00fhtvQMeta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/[...url].vue?macro=true";
import { default as indexQ7epqb6YyTO8s0shnxSQCRiu_7TIBjylgYUf9h1FjFIMeta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/sok/index.vue?macro=true";
import { default as loginCallbackKUp1qcAI_LaFIX2LWknDeQ_lcDyYrBLkasVJI8Vr8u4Meta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/loginCallback.vue?macro=true";
import { default as microsoftpQKammGWarChEzeXIlzk9TnkizaPQvJnvUPAOJkfQ5sMeta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/esim/microsoft.vue?macro=true";
import { default as logoutCallbackRSMZMxqG7wykeblJdy7Ulv6Fej7g27p6RCNK0nACwg8Meta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/logoutCallback.vue?macro=true";
import { default as sokPageNamejqQ5_OyFMNP6ZvogUM_iClENBsFtAnSihwCTaC3ZmFgMeta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/sok/sokPageName.ts?macro=true";
import { default as loginCallbackTweBoxfCut6J6mMCIY8FVWJTAV7hO7F28a6ydlcZ_5cQx7S7oMeta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/loginCallbackTweBox.vue?macro=true";
import { default as produkterapyROP0Eg8sxyvu6kOCiEmNxJr_W3A8dH3pQg3FCFLcMeta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/tv/bestill/produkter.vue?macro=true";
import { default as oppsummering0O6rFPOl8j4I2wjl_w_jDVwiaGfaaZ0s3xHSmEI0d3MMeta } from "/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/tv/bestill/oppsummering.vue?macro=true";
export default [
  {
    name: "project-state",
    path: "/project-state",
    meta: { ...(project_45stategvVFtUXX0Lf8N7mTSxtiDncS9DsgOVLhkym0T6Mra6cMeta || {}), ...{"middleware":[]} },
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/modules/project-analysis/runtime/pages/project-state.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexjPEy6CQOiNh1rNT9pfifvZsdJSLNlrgYKYEgtHdsn70Meta || {},
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginFc55R6x1suliyj2smacEE_t3PloOSaTKxMWatG1BHoMMeta || {},
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutgXQGpQCZQ7YlEuJoHuP5jnWB6sl68iYhX0rB9Ze6RYkMeta || {},
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/logout.vue")
  },
  {
    name: "CMS-managed page",
    path: "/:url(.*)*",
    meta: _91_46_46_46url_93aUAWQ3siV731zx1RHekBzO8wj3NrnbmGgm9Q00fhtvQMeta || {},
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/[...url].vue")
  },
  {
    name: "sok",
    path: "/sok",
    meta: {"middleware":["resolve-segment-middleware","get-globals-middleware","update-chat-middleware"]},
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/sok/index.vue")
  },
  {
    name: "loginCallback",
    path: "/loginCallback",
    meta: { ...(loginCallbackKUp1qcAI_LaFIX2LWknDeQ_lcDyYrBLkasVJI8Vr8u4Meta || {}), ...{"middleware":[]} },
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/loginCallback.vue")
  },
  {
    name: "ESIM Microsoft",
    path: "/esim/microsoft",
    meta: {"middleware":["resolve-segment-middleware","get-globals-middleware"]},
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/esim/microsoft.vue")
  },
  {
    name: "logoutCallback",
    path: "/logoutCallback",
    meta: logoutCallbackRSMZMxqG7wykeblJdy7Ulv6Fej7g27p6RCNK0nACwg8Meta || {},
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/logoutCallback.vue")
  },
  {
    name: "sok-sokPageName",
    path: "/sok/sokPageName",
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/sok/sokPageName.ts")
  },
  {
    name: "loginCallbackTweBox",
    path: "/loginCallbackTweBox",
    meta: { ...(loginCallbackTweBoxfCut6J6mMCIY8FVWJTAV7hO7F28a6ydlcZ_5cQx7S7oMeta || {}), ...{"middleware":[]} },
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/loginCallbackTweBox.vue")
  },
  {
    name: "tv-bestill-produkter",
    path: "/tv/bestill/produkter",
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/tv/bestill/produkter.vue")
  },
  {
    name: "tv-bestill-oppsummering",
    path: "/tv/bestill/oppsummering",
    component: () => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/pages/tv/bestill/oppsummering.vue")
  }
]